import { render, staticRenderFns } from "./AdminContainer.vue?vue&type=template&id=70d90f6a&scoped=true"
import script from "./AdminContainer.vue?vue&type=script&lang=js"
export * from "./AdminContainer.vue?vue&type=script&lang=js"
import style0 from "./AdminContainer.vue?vue&type=style&index=0&id=70d90f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d90f6a",
  null
  
)

export default component.exports